import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[libDynamicDataHost]'
})
export class DynamicDataHostDirective {

  constructor(public viewContainerRef: ViewContainerRef) { }

}
